import { render } from "./singleformation.vue?vue&type=template&id=1581bf62&scoped=true"
import script from "./singleformation.vue?vue&type=script&lang=js"
export * from "./singleformation.vue?vue&type=script&lang=js"

import "./singleformation.vue?vue&type=style&index=0&id=1581bf62&lang=css"
import "./singleformation.vue?vue&type=style&index=1&id=1581bf62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1581bf62"]])

export default __exports__